/* eslint-disable */

<template>
  <div class="b-signature-landing-container">
    <div :class="loading"></div>
    <div v-if="errorMessage">
      <h3 style="text-align: center">Error in fetching data, Please reload the page</h3>
    </div>
    <div style="{padding:15px}" v-else>
      <div class="b-signature-landing-container__nav">
        <div
          class="b-signature-landing-container__nav-tab"
          v-for="tab in tabs"
          :key="tab.name"
          v-on:click="changeCurrentTabHandler(tab.name)"
        >
          <div class="b-signature-landing-container-heading__row">
            <h2 class="b-signature-landing-container-heading">{{tab.name}}</h2>
            <div v-if="tab.totalCount !==null">
              <h2 class="b-signature-landing-container-heading">({{tab.totalCount}})</h2>
            </div>
          </div>
          <div :class="{'b-skyc-landing-container__active': currentTab === tab.name }"></div>
          <!-- <h1 >KYC Details</h1> -->
        </div>
      </div>
      <div v-if="signature_details.length>0">
        <table>
          <thead>
            <tr>
              <th>S.No</th>
              <th>Id</th>
              <th>Name</th>
              <th>PAN <input type="search" v-model="searchByPan" style="margin-left:10px;" placeholder="Search by PAN.." class="bordered"></th>
              <th>
                Created Date
                <a
                  href
                  v-on:click.stop.prevent="sortByDate('createdAt','desc')"
                  v-if="sortByCreatedDate===true"
                >
                  <span>
                    <img src="../../assets/sort_asc.png" class="b-signature-landing-container__sort-icon" />
                  </span>
                </a>
                <a
                  href
                  v-on:click.stop.prevent="sortByDate('createdAt','asc')"
                  
                  v-else-if="sortByCreatedDate===false"
                >
                  <span>
                    <img
                      src="../../assets/sort_desc.svg"
                      class="b-signature-landing-container__sort-icon"
                    />
                  </span>
                </a>
                <a href v-on:click.stop.prevent="sortByDate('createdAt','asc')" v-else>
                  <span>
                    <img
                      src="../../assets/sort_icon.svg"
                      class="b-signature-landing-container__sort-icon"
                    />
                  </span>
                </a>
              </th>
              <th>
                Update Date
                <a
                  href
                  v-on:click.stop.prevent="sortByDate('updatedAt','desc')"
                  
                  v-if="sortByUpdatedDate===true"
                >
                  <span>
                    <img src="../../assets/sort_asc.png" class="b-signature-landing-container__sort-icon" />
                  </span>
                </a>
                <a
                  href
                  v-on:click.stop.prevent="sortByDate('updatedAt','asc')"
                
                  v-else-if="sortByUpdatedDate===false"
                >
                  <span>
                    <img
                      src="../../assets/sort_desc.svg"
                      class="b-signature-landing-container__sort-icon"
                    />
                  </span>
                </a>
                <a href v-on:click.stop.prevent="sortByDate('updatedAt','asc')" v-else>
                  <span>
                    <img
                      src="../../assets/sort_icon.svg"
                      class="b-signature-landing-container__sort-icon"
                    />
                  </span>
                </a>
              </th>
              <th>Email id <input type="search" v-model="searchByEmail" style="margin-left:10px;" placeholder="Search by email.." class="bordered"></th>
              <th
                v-if="$route.params.status=='RejectedByAdmin' || $route.params.status=='RejectedByCVL'"
              >Error Message</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(signature,index) in allSignaturePendingList" :key="signature.id">
              <td>{{index+1}}</td>
              <td>
                <a href v-on:click.stop.prevent="signatureIdDetail(signature.id)">{{signature.id}}</a>
              </td>
              <td>{{signature.attributes.name}}</td>
              <td>{{signature.attributes.PAN_number}}</td>
              <td>{{signature.attributes.createdAt | datetimeFormat}}</td>
              <td>{{signature.attributes.updatedAt | datetimeFormat}}</td>
              <td>{{signature.attributes.email}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else class="b-video-not-found--msg">No record found</div>
    </div>
  </div>
</template>
<script>
import {  mapState } from "vuex";

import Moment from "moment";

export default {
  data() {
    return {
      signature_details: [],
      loaded: false,
      signatureDetails: null,
      filterFlag: false,
      createdDate_asc: null,
      updatedDate_asc: null,
      errorMessage: false,
      // tabs: ["Pending", "Submitted", "RejectedByAdmin", "RejectedByCVL"],
      tabs: [
        { name: "signatureVerificationPending", totalCount: null },
        // { name: "Submitted", totalCount: null },
        // { name: "RejectedByAdmin", totalCount: null },
        // { name: "RejectedByCVL", totalCount: null },
        // { name: "ConsentFormTrue", totalCount: null },
      ],
      currentTab: { name: "signatureVerificationPending", totalCount: null },
      allData: false,
      searchByPan: null,
      searchByEmail: null
    };
  },
  async mounted() {
    this.$store.commit("resetSignatureTab");
    this.$store.commit('set_admin_partner', this.$route.params.partner)
    this.$store.commit('set_kyc_verification_type', 'signature')
    await this.$store
      .dispatch("fetchSignatureData", '')
      .then(() => {
        this.tabs[0].totalCount = this.signatureData.length
        this.showVerifySignatureList();
      })
      .catch(err => {
        console.log("err",err)
        this.errorMessage = true});
  },
  methods: {

    signatureIdDetail: function(id) {
      this.$store.commit("resetSignatureTab")
      this.$router.push({ name: "verify-signature-details", params: { id: id , params: this.admin_partner} });
      this.$store.commit("removeUserDetails");
    },

    filterStatus(status) {
      this.filterFlag = true;
      this.signature_details = this.signature_details.filter(
        element => element.kyc_form_check_status === status
      );
    },
    removeFilter() {
      this.filterFlag = false;
      this.showVerifySignatureList();
    },
    showVerifySignatureList() {
      this.currentTab = this.$route.params.status;
      this.signature_details = this.signatureData;
    },

    showVideoData(type) {
      this.tabs[0].totalCount = 0;
      let route_param = this.$route.params.status;
      this.allData = true;

      if(type == 'on_hold') {
        route_param = "IpvVerificationPending";
        this.allData = false;
      }

      this.$store
        .dispatch(`fetchSignatureData`, type)
          .then(() => {
            this.tabs[0].totalCount = this.signatureData.length
            this.changeCurrentTabHandler(route_param);
            this.showVerifySignatureList();
          })
        .catch(err  => {
          console.log("err",err)
          this.errorMessage = true});
    },

    sortByDate(type, sortOrder) {
      let data = [...this.signature_details];
      if (type === "createdAt") {
        // this.updatedDate_asc = null;
        this.$store.commit("setSortingByDate",{sortByUpdatedDate:null});
        if (sortOrder === "asc") {
          // this.createdDate_asc = true;
          this.$store.commit("setSortingByDate",{sortByCreatedDate:true});
          data.sort((a, b) => new Date(b[type]) - new Date(a[type]));
        } else {
          // this.createdDate_asc = false;
            this.$store.commit("setSortingByDate",{sortByCreatedDate:false});
          data.sort((a, b) => new Date(a[type]) - new Date(b[type]));
        }
      }
      if (type === "updatedAt") {
        // this.createdDate_asc = null;
          this.$store.commit("setSortingByDate",{sortByCreatedDate:null});
        if (sortOrder === "asc") {
          // this.updatedDate_asc = true;
          this.$store.commit("setSortingByDate",{sortByUpdatedDate:true});
          data.sort((a, b) => new Date(b[type]) - new Date(a[type]));
        } else {
          // this.updatedDate_asc = false;
          this.$store.commit("setSortingByDate",{sortByUpdatedDate:false});
          data.sort((a, b) => new Date(a[type]) - new Date(b[type]));
        }
      }

      this.signature_details = data;
    },
    changeCurrentTabHandler(tab) {
      this.currentTab = tab;
      this.$router.replace({ name: 'verify-signature', params: {status: tab, partner: this.admin_partner}});
      this.showVerifySignatureList();
    },
    checkKycStatus(status){
         switch (status) {
            case "2":
              return 'Pending'
            case "4":
            case "5":
              return 'Submitted'
            case "3":
              return 'Rejected By Admin'
            case "6":
              return 'Rejected By CVL'
          }
    }
  },
  computed: {
    ...mapState({
      signatureData: state => state.signatureDetails.signatureData,
      sortByCreatedDate: state => state.signatureDetails.sortByCreatedDate,
      sortByUpdatedDate: state => state.signatureDetails.sortByUpdatedDate,
      admin_partner: state => state.kycLogin.admin_partner,
      kyc_verification_type: state => state.kycLogin.kyc_verification_type
      
    }),
    getDetails() {
      return this.$store.state.signatureDetails.signatureData;
    },
    loading() {
      return {
        loader: this.$store.state.signatureDetails.loading
      };
    },
    allSignaturePendingList() {
      if(this.searchByPan) {
        return this.signature_details.filter(obj => {
                if(obj.attributes.PAN_number) {
                  return (obj.attributes.PAN_number.indexOf(this.searchByPan.toUpperCase()) > -1)
                } else {
                  return false;
                }
              });
      } else if(this.searchByEmail) {
        return this.signature_details.filter(obj => {
                if(obj.attributes.email) {
                  return (obj.attributes.email.indexOf(this.searchByEmail) > -1)
                } else {
                  return false;
                }
              });
      } else {
        return this.signature_details;
      }
    }
  },
  watch: {
    "$route.params.status": function(status) {
      this.currentTab = status;
      this.showVerifySignatureList();
    }
  },

  filters: {
    datetimeFormat: function(value) {
      if (value) {
        return Moment(value).format("DD/MM/YYYY");
      }
    },
    booleanFilter(value){
    return value? " YES ":" NO ";
    },

  },
};
</script>

<style scoped>
.b-signature-landing-container {
  margin-top: 40px;
}
.b-signature-landing-container-heading {
  text-align: center;
  margin-bottom: 8px;
  cursor: pointer;
}
.b-signature-landing-container__nav {
  display: flex;
  justify-content: space-around;
  margin-bottom: 45px;
}
.b-skyc-landing-container__active {
  border: solid 1.5px #2b3d51;
}
tbody tr:hover {
  background-color: aliceblue;
}

table {
  text-align: center;
  border-collapse: collapse;
  width: 100%;
}

td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

.b-signature-landing-container__sort-icon {
  width: 12px;
  height: 12px;
}
.b-video-not-found--msg {
  display: flex;
  justify-content: center;
}
.b-signature-landing-container-heading__row {
  display: flex;
}
.b-video-rejected{
color: #ff0000
}
.b-video-data-link__active {
  text-decoration: none;
}

/* td a{
  text-decoration: none;
} */

/* Safari */
</style>